import { useBrandVisualKit } from 'hooks/queries/workspaces/useBrandVisualKit'
import Styles from './TextStylesDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { TextStyle } from '../TextTab/BrandKitTextStyles/TextStyle'
import { FONT_ROLES_LABELS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { TextBoxShapeProps } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'

interface Props {
  brandVisualKitId: number
  onSelect: (props: Partial<TextBoxShapeProps>) => void
}

const BrandKitTextStyles = ({ brandVisualKitId, onSelect }: Props) => {
  const { data } = useBrandVisualKit({ id: brandVisualKitId })

  const textStyles = data?.brand_visual_kit.text_styles ?? []

  if (textStyles.length === 0) {
    return null
  }

  return (
    <div className={Styles.section}>
      <Text variant="largeList">Brand Styles</Text>
      <div className={Styles.textStyles}>
        {textStyles.map((textStyle) => (
          <TextStyle
            key={textStyle.id}
            textStyle={textStyle}
            label={FONT_ROLES_LABELS[textStyle.font_role]}
            onPress={onSelect}
          />
        ))}
      </div>
    </div>
  )
}

export { BrandKitTextStyles }
